import { defineMessages } from 'react-intl';

export const countryMessages = defineMessages({
  nationalTeam: {
    id: 'Seo.Country.nationalTeam',
    defaultMessage: '{country} National Football Team',
  },
} as const);
